import { isObject, isServiceError } from '../isServiceError';
export class SessionTimeoutFilter {
  isLoggable(record) {
    const [maybeError] = record.messages;
    if (!(maybeError instanceof Error)) {
      return true;
    }
    const cause = maybeError.cause;
    if (!isServiceError(cause)) {
      return true;
    }
    const {
      error: {
        status,
        responseJSON
      }
    } = cause;
    return !(status === 401 && isObject(responseJSON) && 'message' in responseJSON && typeof responseJSON.message === 'string' && responseJSON.message.includes('Session timed out'));
  }
}